import { ConfigObject } from "shared"

const config: ConfigObject = {
	site: "present",
	includeLogoInPdf: true,
	userType: "present",
	baseGetAppsParams: {
		processedOnly: false,
		excludeDuplicates: true,
		attrList: ["candidateName", "receivedTime", "identifier", "submittedBy"],
	},
	baseGetTemplatesParams: {
		attributes: ["templateName", "createdTime", "templateVersion", "lastModifiedTime", "live"],
	},
	createPresentRoleOnClients: true,
	homepage: "/candidates",
	captchaKey:
		process.env.VITE_IS_TEST === "true" || process.env.VITE_IS_DEV === "true"
			? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
			: (process.env.VITE_CAPTCHA_KEY ?? "6Ld5bpYeAAAAALSw49zzZAoaBvQGl9PKL8kzcGN_"),
	MAX_LOGO_SIZE: 1500000,
	localDefaultSettings: {
		recruiterPhoto: { initState: null, storageName: "recruiterPhoto", sessionOnly: false },
		recruiterName: { initState: null, storageName: "recruiterName", sessionOnly: false },
		companyName: { initState: null, storageName: "companyName", sessionOnly: false },
		recruiterEmail: { initState: null, storageName: "recruiterEmail", sessionOnly: false },
		recruiterPhone: { initState: null, storageName: "recruiterPhoneNumber", sessionOnly: false },
		jobTitle: { initState: "", storageName: "jobTitle", sessionOnly: false },
	},
	accessPermissions: {
		admin: {
			settings: "write",
			templates: "write",
			editing: "write",
			branding: "write",
		},
		recruiter: {
			settings: "read",
			templates: "read",
			editing: "write",
			branding: "none",
		},
		brandEditor: {
			settings: "read",
			templates: "write",
			editing: "write",
			branding: "write",
		},
	},
	storageKeys: {
		application: [
			//'totalExperience',
			"submittedBy",
			//'averageTenure',
			//'candidateName',
			//'emailAddress',
			"miscData",
			//'score',
			//'phoneNumber',
			"application_id",
			"fileTypes",
			"identifier",
			//'linkedUrl',
			"receivedTime",
		],
	},
	s3: {
		REGION: process.env.VITE_REGION || "eu-west-2",
		BUCKET: "logobucket-46e98a4c-0804-11eb-8223-48d705e1ba8b",
	},
	apiGateway: {
		NAME: "ara_db_api",
		REGION: process.env.VITE_REGION || "eu-west-2",
		URL: process.env.VITE_API_URL || "https://bm95seyh19.execute-api.eu-west-2.amazonaws.com/Prod",
	},
	apiGatewayPublic: {
		NAME: "ara_db_public_api",
		REGION: process.env.VITE_REGION || "eu-west-2",
		URL: process.env.VITE_PUBLIC_API_URL || "https://api.hireara.ai",
	},
	apiGatewayCustomPublic: {
		NAME: "ara_db_custom_public_api",
		REGION: process.env.VITE_REGION || "eu-west-2",
		URL: process.env.VITE_CUSTOM_PUBLIC_API_URL,
	},
	apiGatewayLinks: {
		NAME: "ara_db_links_api",
		REGION: process.env.VITE_REGION || "eu-west-2",
		URL: process.env.VITE_LINKS_API_URL,
	},
	apiGatewayEvo: {
		NAME: "ara_db_evo_api",
		REGION: process.env.VITE_REGION || "eu-west-2",
		URL: process.env.VITE_EVO_API_URL,
	},
	cognito: {
		REGION: process.env.VITE_REGION || "eu-west-2",
		USER_POOL_ID: process.env.VITE_USER_POOL_ID || "eu-west-2_Kxohac48f",
		APP_CLIENT_ID: process.env.VITE_USER_POOL_CLIENT_ID || "2d3mlunt9sga587kdj6lullio0",
		DOMAIN: process.env.VITE_COGNITO_DOMAIN || "dev-hireara.auth.eu-west-2.amazoncognito.com",
		// IDENTITY_POOL_ID: "eu-west-2:e5b18e71-1983-4cf1-9914-6a63536d67fc"
	},
	evoConfig: {
		ACCESS_IDENTITY_URL: process.env.VITE_ACCESS_IDENTITY_URL || "https://preprodidentity.accessacloud.com",
		IDENTITY_ENABLED: true,
	},
}

console.log("setting config")
global.config = config

export { config }
